import { attributes, AttributesMixin, define, Model, type } from "@type-r/models";
import { isEmpty } from "lodash";
import { poll } from "../shared";
import { AssetTypeItem } from "./assetTypes";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";

export interface ArchivedAsset extends AttributesMixin<typeof ArchivedAsset> { }
@define
export class ArchivedAsset extends Model {

    static idAttribute = "uid";

    static attributes = {
        uid: String,
        documentId: String,
        isArchived: Boolean
    }

}

export interface ArchivedAssets extends AttributesMixin<typeof ArchivedAssets> { }
@define
export class ArchivedAssets extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assets/archived');

    static attributes = {
        items: [ArchivedAsset],
        count: Number
    }

    async getArchivedAssets(importJobId): Promise<ArchivedAssets> {
        const url = `api/v1/assetmaster/assets/archived?importJobId=${importJobId}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: new Headers({
                "Authorization": getAuthorizationBearer(),
                'X-Platform-Code': getPlatformCode()
            }),
        });

        if (response.status < 200 || response.status >= 300) {
            let error = response.statusText || `HTTP Error ${response.status}`;
            await response.json()
                .then(e => error = e.error)
                .catch(e => console.error('Cannot parse response data'));
            throw new Error(error);
        }

        const json = await response.json();

        this.set(json);
        return this;
    }
}
